import { useSyncExternalStore } from 'react'

import getGlobal from '~/src/Lib/getGlobal'

import { MOBILE_LANDSCAPE_MEDIA_QUERY, MOBILE_LAYOUT_MEDIA_QUERY } from './mobileQuery'

export { MOBILE_LANDSCAPE_MEDIA_QUERY, MOBILE_LAYOUT_MEDIA_QUERY }

// This pair is the only place that decides when the phone layout is active. CSS keys use the constants;
// JS reads use getIsMobileLayout / useIsMobileLayout / the store's selectIsMobile. Mobile means a phone:
// touch as the primary input on a phone-sized screen (see mobileQuery). Width tiers (theme.breakpoints, useBreakpoint) and the native shell
// (isNativePlatform) are different questions and stay out of here.

// matchMedia takes the bare list; the `@media` prefix is for CSS-in-JS keys and MUI.
const createList = () => getGlobal()?.matchMedia?.(MOBILE_LAYOUT_MEDIA_QUERY.replace(/^@media\s*/, '')) ?? null

export const getIsMobileLayout = (): boolean => createList()?.matches ?? false

export const subscribeMobileLayout = (onChange: () => void): (() => void) => {
  const list = createList()
  if (!list) return () => undefined
  list.addEventListener('change', onChange)
  return () => list.removeEventListener('change', onChange)
}

export const useIsMobileLayout = (): boolean => useSyncExternalStore(subscribeMobileLayout, getIsMobileLayout)
